// © Microsoft Corporation. All rights reserved.

export enum ErrorBehavior {
    /** This app error can trigger exceptional behavior */
    Exceptional,

    /** This app error can trigger fallback behavior */
    Fallback
}